import { Message, MessageType } from '@dreryk/react-components';

import { guardiansTranslationKeys } from '../../../translations';

type RequiredAddressDataForStatutoryRepresentativeStatusProps = {
   readonly addressRequired: boolean;
};

export const RequiredAddressDataForStatutoryRepresentativeStatus = (
   props: RequiredAddressDataForStatutoryRepresentativeStatusProps
): JSX.Element | null => {
   if (!props.addressRequired) {
      return null;
   }

   return (
      <Message
         type={MessageType.WARNING}
         displayIndicator
         label={guardiansTranslationKeys.requiredAddressDataForStatutoryRepresentative}
         testId={'requiredAddressDataForStatutoryRepresentative'}
      />
   );
};
